module.exports = __webpack_public_path__ + "img/4-4.b9072c3f.svg";